<template>
  <div class="user_wrap">
    <BreadCrumb crumb="用户管理"></BreadCrumb>
    <div class="top_bar">
        <el-row>
          <el-col :span="5">
            <el-input placeholder="请输入搜索内容: 账号/手机号" v-model="keyword" class="input-with-select" size="small">
              <!-- <el-button slot="append" icon="el-icon-search" @click="fnGetData(1)"></el-button> -->
            </el-input>
          </el-col>

           <el-col :span="5" :offset='1'>
              <template>
                <el-select  size="small" v-model="status" placeholder="请选择状态">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </template>
          </el-col>

          <el-col :span="2" >
            <div class="find" @click='fnGetData(1)'>查询</div>
          </el-col>

          <el-col :span="3" :offset="8"><AddUser @fnSetKey="fnGetKey" class="pull-right"></AddUser></el-col>

          <!-- <el-col :span="8" :offset="8"><AddUser @fnSetKey="fnGetKey" class="pull-right"></AddUser></el-col> -->
        </el-row>
    </div>
    <div class="top_bar">
        <el-row>
          <el-col :span="2">
            <div class="batch_operation" @click='passUserInfo()'>批量操作</div>
          </el-col>
          <el-col :span="2" :offset='2'>
            <div class="batch_operation" @click='passUser(0)'>冻结</div>
          </el-col>
          <el-col :span="2">
            <div class="export_data" @click='passUser(1)'>解冻</div>
          </el-col>
          <!-- <el-col :span="5">
            <div class="export_data">导出</div>
          </el-col> -->
        </el-row>
    </div>
    <UserTable :users="aUserList" :selectedObj="selectArr" @fnResetTable="fnGetData"></UserTable>
    <el-pagination
      background
      layout="prev, pager, next"
      :page-count="pages"
      :current-page="page"
      style="text-align:center;margin-top:10px"
      @current-change="fnGetPage"
      >
    </el-pagination>
  </div>
</template>

<script>
import BreadCrumb from '@/components/widget/BreadCrumb'
import AddUser from '@/components/widget/AddUser'
import UserTable from '@/components/widget/UserTable'
import cons from '@/components/constant'

export default {
  name: 'User',
  data () {
    return {
      options: [{
          value: '0',
          label: '冻结'
        },
        {
          value: '1',
          label: '正常'
        }
      ],
      keyword:'',
      page:1,
      pages:8,
      pagesize:10,
      status: '',
      aUserList:[],
      selectArr:[]
    }
  },
  components:{
    BreadCrumb,
    AddUser,
    UserTable
  },
  mounted(){
    this.fnGetData(1);
  },
  methods:{
    fnGetData:function(num){
      let token = localStorage.token;
      this.axios.get(cons.apis + '/v1_0/users', {
          headers: {
            'Authorization': 'Bearer ' + token
          },
          responseType: 'json',
          params:{
            page:num,
            status: this.status===''?1:this.status,
            keyword: this.keyword,
            order_by: 'id',
            per_page:this.pagesize
          }
      })
      .then(dat=>{
          this.aUserList = dat.data.data.users;
          this.aUserList.reverse()
          this.page = num;
          this.pages = dat.data.data.total_count;
      }).catch(err=>{
         console.log(err);
      });
    },
    fnGetKey:function(dat){
       this.keyword = dat;
       this.fnGetData(1);
    },
    fnGetPage:function(dat){
      this.page = dat;
      this.fnGetData(this.page);
    },
    passUserInfo:function(){
      this.$message({
        type: 'info',
        message: '选定用户后，点击冻结或解冻!'
      });
    },
    passUser:function(sta){
      var arr = this.selectArr
      if(arr.length === 0){
        this.$message({
          type: 'error',
          message: '请先选定用户，然后点击冻结或解冻!'
        });
        return
      }
      let token = localStorage.token;
      this.axios.put(cons.apis + '/v1_0/users',{
          "user_ids": arr,  // 用户id列表
          "status": sta // 1解冻 0冻结
        },{
          headers: {
            'Authorization': 'Bearer ' + token
          },
          responseType:'json'
      }).then(dat=>{
        this.$message({
          type: 'success',
          message: '修改成功!'
        });
        this.fnGetData(1)
      }).catch(err=>{
        console.log(err)
        if(err.response.status==404){
           this.$message({
              type:'info',
              message:'用户未找到！'
            });
        }
      })
    }
  }
}
</script>

<style scoped>
.top_bar{
  width:95.2%;
  overflow:hidden;
  margin:10px auto 10px;
}
.batch_operation, .export_data {
  width: 80px;
  height: 32px;
  color: #fff;
  font: 12px/32px 'simsun';
  text-align: center;
  background-color: #FB5557;
  border-radius: 3px;
  cursor: pointer;
}
.batch_operation:hover, .export_data:hover {
  background-color: rgb(252, 119, 121);
}
.find {
  width: 92px;
  height: 38px;
  color: #fff;
  font: 12px/38px 'simsun';
  text-align: center;
  background-color: #FB5557;
  border-radius: 3px;
  cursor: pointer;
}
.find {
  width: 80px;
  height: 32px;
  line-height: 32px;
  margin-left: 140px;
}
.batch_operation:hover, .export_data:hover, .find:hover {
  background-color: rgb(252, 119, 121);
}

</style>



// WEBPACK FOOTER //
// src/components/pages/User.vue